import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mode-keyboard-shortcuts',
  templateUrl: './keyboard-shortcuts.component.html',
  styleUrl: './keyboard-shortcuts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyboardShortcutsComponent {
  @Input() itemExpandedOrCollapsed!: Record<string, boolean>;
  @Output() toggle = new EventEmitter<string>();

  constructor() {}

  toggleSection(section: string) {
    this.toggle.emit(section);
  }

  isOpenSection(topic: string): boolean {
    return !!this.itemExpandedOrCollapsed[topic];
  }
}
